import { render, staticRenderFns } from "./Faturamento.vue?vue&type=template&id=5ef5b3db"
import script from "./Faturamento.vue?vue&type=script&lang=js"
export * from "./Faturamento.vue?vue&type=script&lang=js"
import style0 from "./Faturamento.vue?vue&type=style&index=0&id=5ef5b3db&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports